/**
 * Deduplicação simples por evento+chave em janela temporal curta.
 * Previne disparos duplicados (ex.: React StrictMode, double click,
 * remount de rota).
 */

type Key = string;

const cache = new Map<Key, number>();
const DEFAULT_WINDOW_MS = 1500;

function compose(eventName: string, key?: string): Key {
  return `${eventName}::${key || ''}`;
}

export const EventDeduplicator = {
  /**
   * Retorna true se o evento DEVE ser disparado (não foi visto recentemente).
   * Retorna false se está dentro da janela de dedup.
   */
  shouldDispatch(eventName: string, key?: string, windowMs: number = DEFAULT_WINDOW_MS): boolean {
    const k = compose(eventName, key);
    const now = Date.now();
    const last = cache.get(k);
    if (last && now - last < windowMs) return false;
    cache.set(k, now);
    // Limpeza ocasional do cache
    if (cache.size > 500) {
      const cutoff = now - 60000;
      cache.forEach((ts, key) => {
        if (ts < cutoff) cache.delete(key);
      });
    }
    return true;
  },

  reset(): void {
    cache.clear();
  },
};

export default EventDeduplicator;
